import React from "react";
import { useSelector } from "react-redux";
import { Link } from "components/core/Link";
import { ensureAbsoluteUrl } from "utils/url";
import states from "config/states";

import "./StateLinks.scss";

function StateLinks() {
	const baseUrl = useSelector((state) => state.app?.baseUrl);
	return (
		<ul className="states-list">
			{states.map(({ abbv, url }) => (
				<li
					className="state"
					key={abbv}
				>
					<Link
						last
						weight="semiBold"
						color="lightBlue"
						className="state-link"
						href={ensureAbsoluteUrl(url, baseUrl)}
					>
						{abbv}
					</Link>
				</li>
			))}
		</ul>
	);
}

export { StateLinks as UnconnectedStateLinks };

export default StateLinks;
